module.exports = __webpack_public_path__ + "assets/4b40301560c53c8183faec4bf2937ab8.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WildLandR.mp3
 ** module id = 385
 ** module chunks = 0
 **/